import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { SwiperFacade } from './state/swiper/swiper.facade';
import { SWIPER_INTERACTION_EMITTER, SwiperInteractionEvent } from './state/swiper/swiper.models';

@NgModule({
  imports: [CommonModule],
  providers: [
    SwiperFacade,
    {
      provide: SWIPER_INTERACTION_EMITTER,
      useValue: new BehaviorSubject<SwiperInteractionEvent>({
        type: 'INIT',
        index: 0,
      }),
    },
  ],
})
export class SharedDataAccessSwiperModule {}
